import React, { FunctionComponent } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, Grid } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

const useStyle = makeStyles({
    wrapper: {
        backgroundColor: "rgba(242, 242, 248, 0.7)",
        padding: "10px",
        marginBottom: "0.4em"
    },
    marginRight: {
        marginRight: "0.4em"
    }
});

const TimeDateShowInput: FunctionComponent<{date: string}> = ({date}) => {
    const classes  = useStyle();
    return (
        <Box marginBottom="10px">
            <Grid container>
                <Grid item xs={12} md={4} container wrap="nowrap" alignItems="center">
                    <AccessTimeIcon className={classes.marginRight}/>
                    <Typography>{moment(date).format("MMMM D, YYYY")}</Typography>
                </Grid>
                <Grid item xs={12} md={4} container wrap="nowrap" alignItems="center">
                    <CalendarTodayIcon className={classes.marginRight}/>
                    <Typography> {moment(date).format("h:mm a")} - {moment(date).add(20, "minutes").format("h:mm a")} </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TimeDateShowInput;

